import {setTag} from '@sentry/browser';
import * as PL from '@wix/music-player/lib/index-desktop';
import '@wix/music-player/lib/index-desktop.css';
import {WixMusicWidgetModule} from '../typings/wix-music-widget';
import {widgetPlayer} from './_widget-player';
import {initPreOpened} from './logging/pre-opened';

setTag('widgetOrigin', 'widget-desktop');
initPreOpened();

const PlPromise: Promise<WixMusicWidgetModule> = Promise.resolve(PL);
widgetPlayer(PlPromise);
